module.exports = __webpack_public_path__ + "static/bg-page-10-fe3d5394195f3496c079a82bc41a3645.jpg";